module.exports = __webpack_public_path__ + "img/EMT-MELA_GSE185386.a0b05055.png";